function CallbackRegistry() {
  this.callbacks = {}
}

CallbackRegistry.prototype.register = function(type, func) {
  if (this.callbacks[type] === undefined) {
    this.callbacks[type] = []
  }
  this.callbacks[type].push(func)
}

CallbackRegistry.prototype.invoke = function(type) {
  if (this.callbacks[type] === undefined) {
    throw new Error(`no registered callbacks for type: ${type}`)
  }
  return Promise.all(this.callbacks[type].map(fn => fn()))
    .then(results => {
      return results.reduce((zz, fn) => {
        return [ ...zz, ...fn.call() ]
      }, [])
    })
}

export default () => new CallbackRegistry()
